import { render, staticRenderFns } from "./CardCampo.vue?vue&type=template&id=5ee19923&scoped=true&"
import script from "./CardCampo.vue?vue&type=script&setup=true&lang=js&"
export * from "./CardCampo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee19923",
  null
  
)

export default component.exports